const IntegrationsEnum = {
	OneTrust: 1,
};

module.exports = IntegrationsEnum;
